import { Group, Paper } from "@mantine/core";
import PerfLinkedinRate from "./PerfCanalRate";
import LinkedinResponseQuality from "./LinkedinResponseQuality";

const LinkedinPerf = ({ type }) => {
  return (
    <Paper component={Group} flex={.5} align="stretch" wrap="nowrap" p={"md"}>
      {type.type === "messages" ? (
        <LinkedinResponseQuality type={type} />
      ) : (
        <PerfLinkedinRate type={type} />
      )}
    </Paper>
  );
};

export default LinkedinPerf;
